import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "@/features/auth/state/useAuth";

type Props = {
    children: ReactElement;
};

export const ProtectedRoute = ({ children }: Props) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-slate-100 dark:bg-slate-950">
                <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-500 border-t-transparent" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/auth/login" replace />;
    }

    return children;
};

